/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import { Switch } from "@mui/material";

// Soft UI Dashboard PRO React example components
import DataTable from "Tables/WizardSportsTable";
import SoftSelect from "components/SoftSelect";

import { useSoftUIController } from "context";
import { getData } from "Utils/server";
import { getAuthorizationHeader } from "Utils/helpers";

let oddSettingsOptions = [];
let marketSettingsOptions = [];

let oddSettingsEditCached = false;

// Data
//import dataTableData from "views/moderate-sports-table/data/dataTableData";
/**
 *
 * @param {*} param0
 * @returns
 */
function ModerateSportsTable({
  selectedSport,
  filterData,
  handleStepperButtonStatus,
  handleStepData,
  advancedView,
  showSportPromosSwitch,
}) {
  const [controller, dispatch] = useSoftUIController();
  const { platform, permissions } = controller;
  const [sport, setSport] = useState("");
  const [toggling, setToggling] = useState(false);
  const [sportType, setSportType] = useState("");
  const [oddSettingsAvailable, setSettingsAvailable] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([
    "id",
    "markets_setting_id",
    "odds_setting_inplay",
    "odds_setting_pregame",
    ...(showSportPromosSwitch ? [] : ["promos"]),
  ]);
  const [dataTableData, setDataTableData] = useState({
    columns: [
      { Header: "id", accessor: "id" },
      { Header: "name", accessor: "name", Cell: errorHandlingCell, width: "220" },
      {
        Header: "promos",
        accessor: "promos",
        Cell: makeSwitch,
        width: "120px",
        sortType: (rowA, rowB) => {
          if (rowA.original.promos > rowB.original.promos) return -1;
          if (rowB.original.promos > rowA.original.promos) return 1;
        },
      },
      {
        Header: "pregame",
        accessor: "pregame",
        Cell: makeSwitch,
        width: "125px",
        sortType: (rowA, rowB) => {
          if (rowA.original.pregame > rowB.original.pregame) return -1;
          if (rowB.original.pregame > rowA.original.pregame) return 1;
        },
      },
      {
        Header: "inplay",
        accessor: "inplay",
        Cell: makeSwitch,
        width: "110px",
        headerClasses: "test",
        sortType: (rowA, rowB) => {
          if (rowA.original.inplay > rowB.original.inplay) return -1;
          if (rowB.original.inplay > rowA.original.inplay) return 1;
        },
      },
      {
        Header: "both",
        accessor: "both",
        Cell: makeSwitch,
        width: "100px",
        sortType: (rowA, rowB) => {
          if (rowA.original.both > rowB.original.both) return -1;
          if (rowB.original.both > rowA.original.both) return 1;
        },
      },
      {
        Header: "allow all competitions",
        accessor: "defaultvalue",
        Cell: makeSwitch,
        width: "160px",
        sortType: (rowA, rowB) => {
          if (rowA.original.defaultvalue > rowB.original.defaultvalue) return -1;
          if (rowB.original.defaultvalue > rowA.original.defaultvalue) return 1;
        },
      },
      {
        Header: "Markets Setting",
        accessor: "markets_setting_id",
        width: "160px",
        Cell: formatMarketSetting,
      },
      {
        Header: "Odds Setting inplay",
        accessor: "odds_setting_inplay",
        width: "160px",
        Cell: formatOddSetting,
      },
      {
        Header: "Odds Setting pregame",
        accessor: "odds_setting_pregame",
        width: "160px",
        Cell: formatOddSetting,
      },
    ],

    rows: [],
  });

  /**
   *
   * @param {*} param0
   * @returns
   */
  function errorHandlingCell({ value, ...rest }) {
    const errorVisibility =
      rest.row.original.both || rest.row.original.inplay || rest.row.original.pregame;
    return (
      <div>
        <div>{value}</div>
        <div className="error" style={{ display: !errorVisibility ? "block" : "none" }}>
          please select any Event Type to Proceed
        </div>
      </div>
    );
  }

  function formatOddSetting({ value, ...rest }) {
    return (
      <SoftSelect
        className={oddSettingsEditCached ? "odd-setting-menu" : "odd-setting-menu select-disabled"}
        menuShouldScrollIntoView={false}
        options={oddSettingsOptions}
        customSmall={true}
        size={"small"}
        value={
          oddSettingsOptions
            ? oddSettingsOptions.find((item) => item.value === rest.row.original[rest.column.id])
            : null
        }
        isDisabled={!oddSettingsEditCached}
        onChange={(item) => rowOddSettingsChange(item, rest.row.original, rest)}
      ></SoftSelect>
    );
  }

  function formatMarketSetting({ value, ...rest }) {
    return (
      <SoftSelect
        className={oddSettingsEditCached ? "odd-setting-menu" : "odd-setting-menu select-disabled"}
        menuShouldScrollIntoView={false}
        options={marketSettingsOptions}
        customSmall={true}
        size={"small"}
        value={
          marketSettingsOptions
            ? marketSettingsOptions.find((item) => item.value === rest.row.original[rest.column.id])
            : null
        }
        isDisabled={!oddSettingsEditCached}
        onChange={(item) => rowMarketSettingsChange(item, rest.row.original, rest)}
      ></SoftSelect>
    );
  }

  /**
   *
   * @param {*} param0
   * @returns
   */
  function makeSwitch({ value, ...rest }) {
    let disabled = false;
    if (rest.column.Header === "inplay" || rest.column.Header === "pregame") {
      disabled = rest.row.original.disableType == rest.column.Header;
    }
    if (rest.column.Header === "both") {
      disabled = rest.row.original.disableType;
    }

    return (
      <Switch
        checked={value}
        className={disabled ? "select-disabled" : ""}
        isDisabled={disabled}
        onClick={(event) =>
          disabled ? null : handleTypeChange(event, rest.column.id, value, rest.row.original.id)
        }
        inputProps={{ "aria-label": "controlled" }}
      />
    );
  }

  /**
   *
   * @param {*} e
   * @param {*} type
   * @param {*} value
   * @param {*} sportId
   */
  const handleTypeChange = (e, type, value, sportId) => {
    e.preventDefault();
    //console.log(type, sportId, value);
    let filteredData = { ...dataTableData };
    let tempSports = [...dataTableData.rows];
    const eventTypeSwitches = ["inplay", "pregame", "both"];
    setSport("");
    setDataTableData({});
    setSportType("");

    for (const key in tempSports) {
      if (Object.hasOwnProperty.call(tempSports, key)) {
        const sport = tempSports[key];
        if (sport.id === sportId) {
          if (type === "Competitions Default") {
            type = "defaultvalue";
          }
          let prevTypeValue = sport[type];

          if (eventTypeSwitches.indexOf(type) > -1) {
            sport.both = false;
          }

          if (type === "both") {
            sport.inplay = false;
            sport.pregame = false;
          } else if (type === "inplay") {
            if (sport.pregame && !prevTypeValue) {
              sport.pregame = false;
              sport.both = true;
              setSport(sport.sport);
              break;
            }
            sport.inplay = false;
          } else if (type === "pregame") {
            if (sport.inplay && !prevTypeValue) {
              sport.inplay = false;
              sport.both = true;
              setSport(sport.sport);
              break;
            }
            sport.pregame = false;
          } else if (type === "defaultvalue") {
            type = "defaultvalue";
          }

          sport[type] = !prevTypeValue;
          setSport(sport.sport);
          break;
        }
      }
    }

    validateSportsSwitches(tempSports);

    filteredData.rows = tempSports;
    setDataTableData({});
    setDataTableData(filteredData);
    setToggling(!value);
    setSportType(type);
    handleStepData(tempSports);
  };

  function rowOddSettingsChange(item, row, rest) {
    let filteredData = { ...dataTableData };
    let tempSports = [...dataTableData.rows];
    setSport("");
    setDataTableData({});
    setSportType("");

    for (const key in tempSports) {
      if (Object.hasOwnProperty.call(tempSports, key)) {
        const sport = tempSports[key];
        if (sport.id === row.id) {
          row[rest.column.id] = item.value;
        }
      }
    }

    filteredData.rows = tempSports;
    setDataTableData({});
    setDataTableData(filteredData);
    handleStepData(tempSports);
  }

  function rowMarketSettingsChange(item, row, rest) {
    let filteredData = { ...dataTableData };
    let tempSports = [...dataTableData.rows];
    setSport("");
    setDataTableData({});
    setSportType("");

    for (const key in tempSports) {
      if (Object.hasOwnProperty.call(tempSports, key)) {
        const sport = tempSports[key];
        if (sport.id === row.id) {
          row[rest.column.id] = item.value;
        }
      }
    }

    filteredData.rows = tempSports;
    setDataTableData({});
    setDataTableData(filteredData);
    handleStepData(tempSports);
  }

  /**
   *
   */
  function initData() {
    //console.log("moderate-sport-table:initData");
    handleStepperButtonStatus(true);
    if (filterData) {
      //console.log("setSelectedSport: ", JSON.stringify(filterData));

      let table = dataTableData;
      table.rows = filterData.map((sport) => {
        return {
          ...sport,
          promos: !!sport.promos,
        };
      });

      setDataTableData(table);
      validateSportsSwitches(table.rows);
    }
    handleStepperButtonStatus(false);
  }

  /**
   *
   * @param {*} id
   * @param {*} name
   * @param {*} inplay
   * @param {*} pregame
   * @param {*} both
   * @param {*} selected
   * @param {*} enabled
   * @returns
   */
  function createData(
    id: number,
    name: string,
    inplay: boolean,
    pregame: boolean,
    both: boolean,
    selected: boolean,
    enabled: boolean
  ) {
    return { id, name, inplay, pregame, both, selected, enabled };
  }

  /**
   *
   * @param {*} sports
   */
  function validateSportsSwitches(sports) {
    handleStepperButtonStatus(false);
    for (const key in sports) {
      if (Object.hasOwnProperty.call(sports, key)) {
        const sport = sports[key];
        if (!sport.pregame && !sport.inplay && !sport.both) {
          handleStepperButtonStatus(true);
          break;
        }
      }
    }
  }

  async function fetchOddsSettings() {
    let selectedPlatformId = platform.value;
    let getTemplatesEndpoint = `/api/v1/oddsfilters/platforms/${selectedPlatformId}`;
    let response = await getData(getTemplatesEndpoint, { Authorization: getAuthorizationHeader() });
    if (response != null) {
      oddSettingsOptions = response.data.map((r) => {
        return { value: r.id, label: r.name };
      });
      oddSettingsOptions.unshift({ value: 0, label: "None" });
      setSettingsAvailable(oddSettingsOptions);
    }
    initData();
  }

  async function fetchMarketsSettings() {
    // if (oddSettingsOptions.length > 0) return;
    let selectedPlatformId = platform.value;
    let getTemplatesEndpoint = `/api/v1/marketsfilters/platform/${selectedPlatformId}`;
    let response = await getData(getTemplatesEndpoint, { Authorization: getAuthorizationHeader() });
    if (response != null) {
      marketSettingsOptions = response.data.map((r) => {
        return { value: r.id, label: r.name };
      });
      marketSettingsOptions.unshift({ value: 0, label: "None" });
      // setMarketSettingsAvailable(marketSettingsOptions);
    }
  }

  const handlePermissions = (permissions) => {
    let editOddSettingsEnabled = false;
    let showOddSettingsEnabled = false;

    // console.log(permissions);

    for (let index = 0; index < permissions.length; index++) {
      const permission = permissions[index];
      if (permission == "super") {
        editOddSettingsEnabled = true;
        showOddSettingsEnabled = true;
      }
      if (permission == "feed-settings-odds-edit") {
        editOddSettingsEnabled = true;
        showOddSettingsEnabled = true;
        break;
      }
      if (permission == "feed-settings-odds-show") {
        showOddSettingsEnabled = true;
      }
    }

    oddSettingsEditCached = editOddSettingsEnabled;
  };

  useEffect(() => {
    setSport(selectedSport);
  }, [selectedSport]);

  useEffect(() => {
    //if (oddSettingsOptions.length > 0 && platform) initData();
  }, [oddSettingsAvailable]);

  useEffect(() => {
    if (platform) {
      fetchMarketsSettings();
      fetchOddsSettings();
    }
  }, [platform]);

  useEffect(() => {
    setHiddenColumns(["id"]);
    if (!advancedView)
      setHiddenColumns([
        "id",
        "markets_setting_id",
        "odds_setting_inplay",
        "odds_setting_pregame",
        ...(showSportPromosSwitch ? [] : ["promos"]),
      ]);
  }, [advancedView, showSportPromosSwitch]);

  useEffect(() => {
    if (permissions.length > 0) handlePermissions(permissions);
  }, [permissions]);

  return (
    <DataTable
      table={dataTableData}
      bodyClassName="settlement-fixtures-list"
      hiddenColumns={hiddenColumns}
      selectedsport={sport}
      type={sportType}
      toggle={toggling}
      canSearch
    />
  );
}

// Typechecking props for the DataTable
ModerateSportsTable.propTypes = {
  selectedSport: PropTypes.string,
  filterData: PropTypes.array,
  handleStepperButtonStatus: PropTypes.func,
  handleStepData: PropTypes.func,
  advancedView: PropTypes.bool,
  showSportPromosSwitch: PropTypes.bool,
};

export default ModerateSportsTable;
